module.exports = __webpack_public_path__ + "static/img/26812.1451c4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/A1/26812.png
// module id = QJZ5
// module chunks = 0